import { render, staticRenderFns } from "./pdfLook.vue?vue&type=template&id=2e4ac420"
import script from "./pdfLook.vue?vue&type=script&lang=js"
export * from "./pdfLook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports